<template>
	<div>
		<Header />
		<Carousel v-model="value" loop :height="400" arrow="never" dots="none">
			<CarouselItem>
				<div class="banner"
					:style="{'background': 'url('+require('@/assets/img/tableEntryService/qaBanner.jpg')+') center center no-repeat'}">
					<div>
						<p class="pageType">入表咨询服务</p>
					</div>
				</div>
			</CarouselItem>
		</Carousel>
		<div class="mainContent">
			<p class="partitionRule">企业数据资产入表基础情况调查问卷</p>
			<p class="fontSize16">填写说明：</p>
			<p class="fontSize16" style="border-bottom: 1px dashed #ccc;padding-bottom: 26px;margin-bottom: 40px;">
				本问卷旨在评估企业数据资产入表的潜力，请根据实际情况填写。选择题可直接勾选（✔），开放式问题请简要说明。感谢您的配合！
			</p>

			<div v-if="content.length>0">
				<p class="baseTitle">一、企业基本信息</p>
				<ul>
					<li>
						<label><span class="reRed">*</span>1.企业名称：</label>
						<input type="text" v-model="content[0].answer" />
					</li>
					<li>
						<label><span class="reRed">*</span>2.所属行业：</label>
						<input type="text" v-model="content[1].answer" />
					</li>
					<li>
						<label><span class="reRed">*</span>3.员工规模:</label>
						<div>
							<RadioGroup v-model="content[2].answer">
								<Radio label="50人以下"></Radio>
								<Radio label="50-200人"></Radio>
								<Radio label="200-500人"></Radio>
								<Radio label="500人以上"></Radio>
							</RadioGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>4.业务范围（请简述主营业务及占比）:</label>
						<input type="text" v-model="content[3].answer" />
					</li>
				</ul>

				<p class="baseTitle">二、数据资产认知与需求</p>
				<ul>
					<li>
						<label><span class="reRed">*</span>5.企业战略中是否提及数据资产化或数字化转型?</label>
						<div>
							<RadioGroup vertical v-model="content[4].answer">
								<Radio label="是">
									<span>是（请简要说明:）</span>
								</Radio>
								<Radio label="否">
									<span>否</span>
								</Radio>
							</RadioGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>6.是否开展过数据资产相关培训或外部咨询?</label>
						<div>
							<RadioGroup vertical v-model="content[5].answer">
								<Radio label="是"></Radio>
								<Radio label="否"></Radio>
							</RadioGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>7.数据资产入表的主要目标（可多选）:</label>
						<div>
							<CheckboxGroup vertical v-model="content[6].answer">
								<Checkbox label="融资支持"></Checkbox>
								<Checkbox label="降低成本"></Checkbox>
								<Checkbox label="提升效率"></Checkbox>
								<Checkbox label="优化决策"></Checkbox>
								<Checkbox label="其他"></Checkbox>
							</CheckboxGroup>
						</div>
					</li>
				</ul>

				<p class="baseTitle">三、数据资产现状</p>
				<ul>
					<li>
						<label><span class="reRed">*</span>8.当前使用的信息化系统（可多选）:</label>
						<div>
							<CheckboxGroup vertical v-model="content[7].answer">
								<Checkbox label="ERP系统"></Checkbox>
								<Checkbox label="CRM系统"></Checkbox>
								<Checkbox label="财务系统"></Checkbox>
								<Checkbox label="数据分析平台"></Checkbox>
								<Checkbox label="其他"></Checkbox>
							</CheckboxGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>9.是否存在实际在使用但暂未入资产负债表的软件系统或数字化工具?</label>
						<div>
							<RadioGroup vertical v-model="content[8].answer">
								<Radio label="是"></Radio>
								<Radio label="否"></Radio>
							</RadioGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>10.核心数据来源部门/业务环节（可多选）:</label>
						<div>
							<CheckboxGroup vertical v-model="content[9].answer">
								<Checkbox label="销售"></Checkbox>
								<Checkbox label="生产"></Checkbox>
								<Checkbox label="财务"></Checkbox>
								<Checkbox label="客户服务"></Checkbox>
								<Checkbox label="研发"></Checkbox>
								<Checkbox label="其他"></Checkbox>
							</CheckboxGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>11.请简要介绍公司目前数据基本情况（主要内容:）</label>
						<div>
							<RadioGroup vertical v-model="content[10].answer">
								<Radio label="生产运营数据:"></Radio>
								<Radio label="客户数据:"></Radio>
								<Radio label="管网数据:"></Radio>
								<Radio label="财务数据:"></Radio>
								<Radio label="其他数据:"></Radio>
							</RadioGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>12.数据存储方式:</label>
						<div>
							<RadioGroup v-model="content[11].answer">
								<Radio label="本地服务器"></Radio>
								<Radio label="云平台"></Radio>
								<Radio label="混合模式"></Radio>
							</RadioGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>13.数据更新频率:</label>
						<div>
							<RadioGroup v-model="content[12].answer">
								<Radio label="实时"></Radio>
								<Radio label="每日"></Radio>
								<Radio label="每月"></Radio>
								<Radio label="每年"></Radio>
							</RadioGroup>
						</div>
					</li>
				</ul>
				<p class="baseTitle">四、数据管理能力</p>
				<ul>
					<li>
						<label><span class="reRed">*</span>14.是否建立数据治理制度（如数据标准、权责划分）?</label>
						<div>
							<RadioGroup v-model="content[13].answer">
								<Radio label="是"></Radio>
								<Radio label="否"></Radio>
							</RadioGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>15.数据质量管理措施（可多选）:</label>
						<div>
							<CheckboxGroup vertical v-model="content[14].answer">
								<Checkbox label="数据清洗"></Checkbox>
								<Checkbox label="校验流程"></Checkbox>
								<Checkbox label="一致性保障"></Checkbox>
								<Checkbox label="无"></Checkbox>
							</CheckboxGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>16.数据安全与隐私保护措施（可多选）:</label>
						<div>
							<CheckboxGroup vertical v-model="content[15].answer">
								<Checkbox label="权限控制"></Checkbox>
								<Checkbox label="数据加密"></Checkbox>
								<Checkbox label="脱敏处理"></Checkbox>
								<Checkbox label="其他"></Checkbox>
							</CheckboxGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>17.是否具备数据中台搭建能力?</label>
						<div>
							<RadioGroup v-model="content[16].answer">
								<Radio label="是"></Radio>
								<Radio label="否"></Radio>
							</RadioGroup>
						</div>
					</li>
				</ul>
				<p class="baseTitle">五、财务与合规性</p>
				<ul>
					<li>
						<label><span class="reRed">*</span>18.是否有研发支出资本化转为无形资产的经验?</label>
						<div>
							<RadioGroup v-model="content[17].answer">
								<Radio label="是"></Radio>
								<Radio label="否"></Radio>
							</RadioGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>19.审计机构对数据资产入表的意见:</label>
						<div>
							<RadioGroup v-model="content[18].answer">
								<Radio label="支持"></Radio>
								<Radio label="保留意见"></Radio>
								<Radio label="未沟通"></Radio>
								<Radio label="其他"></Radio>
							</RadioGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>20.数据权属是否明确（如与第三方共享数据的权责划分）?</label>
						<div>
							<RadioGroup v-model="content[19].answer">
								<Radio label="是"></Radio>
								<Radio label="否"></Radio>
							</RadioGroup>
						</div>
					</li>
				</ul>
				<p class="baseTitle">六、风险与挑战</p>
				<ul>
					<li>
						<label><span class="reRed">*</span>21.数据安全合规性是否符合《个人信息保护法》?</label>
						<div>
							<RadioGroup v-model="content[20].answer">
								<Radio label="完全符合"></Radio>
								<Radio label="部分符合"></Radio>
								<Radio label="不符合"></Radio>
								<Radio label="不确定"></Radio>
							</RadioGroup>
						</div>
					</li>
					<li>
						<label><span class="reRed">*</span>22.当前数据管理的主要瓶颈（可多选）:</label>
						<div>
							<CheckboxGroup vertical v-model="content[21].answer">
								<Checkbox label="数据孤岛"></Checkbox>
								<Checkbox label="技术能力不足"></Checkbox>
								<Checkbox label="缺乏统一标准"></Checkbox>
								<Checkbox label="合规风险"></Checkbox>
								<Checkbox label="其他"></Checkbox>
							</CheckboxGroup>
						</div>
					</li>
				</ul>
				<p class="baseTitle">七、开放性问题</p>
				<ul>
					<li>
						<label><span class="reRed">*</span>23.您认为企业数据资产入表的最大潜力体现在哪些方面?</label>
						<input type="text" v-model="content[22].answer" />
					</li>
					<li>
						<label><span class="reRed">*</span>24.希望获得哪些支持以推动数据资产入表?</label>
						<input type="text" v-model="content[23].answer" />
					</li>
				</ul>
				<div>
					<p style="font-size: 18px;color: #282828;font-weight: bold;"><span class="reRed">*</span>感谢您的参与！</p>
					<p class="lianxi">
						<span>填写人</span>
						<input type="text" v-model="content[24].answer" />
					</p>
					<div class="lianxi">
						<span>联系电话</span>
						<input type="text" v-model="content[25].answer" />
					</div>

					<div class="lianxi">
						<span></span>
						<input type="text" placeholder="请输入图片验证码" @blur="pictureCdoeVerify()" v-model="pictureCode"
							style="margin-right: 20px;" />
						<img class="picture" alt="图形验证码" :src="imgCodeSrc">
						<span class="pictureCodeBtn" @click="getPictureCode()">换一张</span>
					</div>
					<div class="lianxi">
						<span></span>
						<input type="text" placeholder="请输入短信验证码" v-model="noteCode" style="margin-right: 20px;" />
						<Button type="primary" class="getCode buttonFill" :disabled="!!cooling"
							@click="pictureNote(content[25].answer)">
							{{ cooling ? "重新发送(" + cooling + ")" : "获取验证码" }}
						</Button>
					</div>
				</div>

				<p class="fontSize16" style="margin: 60px 0;">
					注:本问卷结果仅用于调研公司入表基础情况，信息将严格保密。
				</p>

				<div class="submit" @click="submit">提交</div>


				<Modal v-model="model" :mask-closable="false" title="提示">
					<p style="font-size: 16px;">{{markedWords}}为必填项</p>
				</Modal>


			</div>

		</div>


		<SignUp />
		<Footer />
	</div>
</template>

<script>
	import Header from '../../common/header/flow_header.vue'
	import Footer from '../../common/footer.vue'
	import publicMethod from '../publicMethod'
	import SignUp from '@/components/signUp/index.vue'

	import qs from 'qs'

	import {
		Modal
	} from 'iview'

	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer,
			SignUp
		},
		data() {
			return {
				value: 0,
				model: false,
				markedWords: '',
				content: [],
				topic: [
					'企业名称', '所属行业', '员工规模', '业务范围', '企业战略中是否提及数据资产化或数字化转型', '是否开展过数据资产相关培训或外部咨询',
					'数据资产入表的主要目标', '当前使用的信息化系统', '是否存在实际在使用但暂未入资产负债表的软件系统或数字化工具', '核心数据来源部门/业务环节',
					'请简要介绍公司目前数据基本情况', '数据存储方式', '数据更新频率', '是否建立数据治理制度（如数据标准、权责划分）', '数据质量管理措施',
					'数据安全与隐私保护措施', '是否具备数据中台搭建能力', '是否有研发支出资本化转为无形资产的经验', '审计机构对数据资产入表的意见',
					'数据权属是否明确（如与第三方共享数据的权责划分）', '数据安全合规性是否符合《个人信息保护法》', '当前数据管理的主要瓶颈',
					'您认为企业数据资产入表的最大潜力体现在哪些方面', '希望获得哪些支持以推动数据资产入表', '填写人', '联系电话'
				],
				cooling: '',
				imgCodeSrc: '',
				uuid: '',
				pictureCode: '',
				noteCode: ''

			}
		},
		mounted() {
			this.init()


		},
		methods: {
			init() {
				this.content = []
				for (var i = 0; i < 26; i++) {
					this.content.push({
						topic: this.topic[i],
						answer: i == 6 || i == 7 || i == 9 || i == 14 || i == 15 || i == 21 ? [] : ''
					})
				}

				this.pictureCode = ''
				this.noteCode = ''

				this.getPictureCode()

			},
			// 获取图片验证码
			getPictureCode() {
				this.$get(this.domain.dataRealization + "dataCustomer/getVerifiCode", "").then((res) => {
					if (res.code == 200 && res.content) {
						this.uuid = res.content.uuid;
						this.imgCodeSrc = res.content.image;
					}
				})
			},
			// 验证图片验证码
			pictureCdoeVerify() {
				var this_ = this;
				if (!this_.pictureCode) {
					this.$Message.warning('请输入图片验证码')
				} else {
					this_.$get(this.domain.dataRealization + "dataCustomer/checkVerifiCode", {
						test: this_.pictureCode,
						uuid: this_.uuid
					}).then((res) => {
						if (res.code != 200) {
							this.$Message.warning('图片验证码不正确')
						}
					})
				}
			},
			pictureNote(value) { //发送短信验证码
				const phone = value.trim()

				if (!phone) {
					this.$Message.warning('请输入手机号')
				} else if (!this.pictureCode) {
					this.$Message.warning('请输入图片验证码')
				} else {
					// 获取验证码
					this.$post(this.domain.dataRealization + 'dataCustomer/sendPhoneCode', qs.stringify({
							verifiCode: this.pictureCode,
							uuid: this.uuid,
							phoneNum: value
						}))
						.then((res) => {
							res = res.data
							if (res.code == 200) {
								this.cooling = 60
								let coolingInter = setInterval(() => {
									if (this.cooling > 0) {
										this.cooling--
									} else {
										clearInterval(coolingInter)
									}
								}, 1000)
							} else {
								this.$Message.error(res.message)
							}
						});
				}

			},
			submit() {
				console.log(this.content)

				var shouldBreak = false; // 标志变量

				for (var i = 0; i < this.content.length && !shouldBreak; i++) {
					if (!this.method.isEmpty(this.content[i].answer)) {
						this.model = true
						this.markedWords = this.content[i].topic

						shouldBreak = true; // 设置标志变量为true，以跳出循环
						break; // 跳出内层循环  
					}
				}

				if (shouldBreak) {
					return false
				}

				this.checkIdentifyingCode()

			},
			checkIdentifyingCode() {
				var obj = {
					phoneNoOrMail: this.content[25].answer,
					code: this.noteCode
				}

				this.$post(this.domain.dataRealization + "dataCustomer/checkIdentifyingCode", qs.stringify(obj)).then((res) => {
					var data = res.data;
					if (data.code == 104) { // 验证码输入错误
						this.$Message.error('短信验证码输入错误')
					} else if (data.code == 106) { // 验证码失效
						this.$Message.error('短信验证码失效')
					} else if (data.code == 200) {
						this.save()
					}
				})
			},
			save() {
				this.$post(this.domain.dataRealization + 'dataAssetBalance/saveConsultInfo', qs.stringify({
						consultInfo: JSON.stringify(this.content)
					}))
					.then(res => {
						if (res.data.code == 200) {

							Modal.confirm({
								render: (h) => {
									return h('div', { // 使用一个div包裹以确保样式应用正确
										style: {
											padding: '20px'
										}
									}, [
										h('p', '请耐心等待，稍后客服人员会联系您'),
									]);
								},
								// content:'请耐心等待，稍后客服人员会联系您',
								onOk: () => {
									this.init()
									console.log('确认按钮被点击')
								}
							})
						}
					})
			}



		}


	}
</script>

<style scoped lang="less">
	.mainContent {
		margin-top: 75px;
	}

	.partitionRule {
		font-size: 28px;
		font-weight: bold;
		color: #282828;
		text-align: center;
		margin-bottom: 40px;
	}

	.fontSize16 {
		line-height: 25px;
		font-size: 16px;
		color: #282828;
	}

	.baseTitle {
		font-size: 20px;
		color: var(--mainColor);
		font-weight: bold;
		margin-bottom: 30px;
	}

	ul {
		li {
			>label {
				display: block;
			}

			label {
				color: #282828;
				font-size: 16px;
				margin-right: 60px;
			}

			label+input {
				width: 400px;
				height: 40px;
				border: 1px solid #e3e3e3;
				margin: 15px 0 30px;
				padding: 0 15px;
				font-size: 16px;
				color: #282828;
			}

			label+input:focus {
				border-color: #1459F4;
			}

			>div {
				margin: 15px 0 30px;
				padding-left: 20px;
			}

		}

	}

	/deep/ .ivu-radio-wrapper {
		margin-bottom: 15px;
	}

	.lianxi {
		display: flex;
		align-items: center;

		span {
			width: 100px;
			color: #282828;
			font-size: 16px;
		}

		input {
			width: 400px;
			height: 40px;
			border: 1px solid #e3e3e3;
			margin: 15px 0;
			padding: 0 15px;
			font-size: 16px;
			color: #282828;
		}
		
		input:focus {
			border-color: #1459F4;
		}
	}

	.submit {
		width: 180px;
		height: 44px;
		line-height: 44px;
		text-align: center;
		background: var(--mainColor);
		font-size: 16px;
		color: #fff;
		cursor: pointer;
		margin: 0 auto;
	}

	.getCode {
		height: 40px;
	}

	.pictureCodeBtn {
		position: relative;
		margin-left: 20px;
		cursor: pointer;
	}
</style>